import { Modal } from 'antd'
import React, { useState } from 'react'
import styled from 'styled-components';
import { AuthArrow, CongratsIcon, LoginMailIcon, PasswordIcon, ShowPassIcon } from '../utils/Images';
import { InputOTP } from 'antd-input-otp';
import { cousntryCodesArr } from '../utils/constants';
import { forgotpassword, updatepassword, verifyotp } from '../collection/ApiCollection';
import { toast } from 'react-toastify';

const ForgotPasswordModal = ({ openorgotPasModal, handleCancelForgotPasModal }) => {
    const [type, setType] = useState(null)
    const [countryCode, setCountryCode] = useState("+1");
    const [password, setPassword] = useState(null);
    const [confirmPassword, setConfirmPassword] = useState(null);
    const [profileStatus, setProfileStatus] = useState(null);
    console.log(profileStatus, "profileStatus")
    const [inputValue, setInputValue] = useState("");
    const [loader, setLoader] = useState(false)
    const handleInputCheck = (e) => {
        const value = e.target.value;
        setInputValue(value);
    };

    const isPhoneNumber = (value) => {
        return /^\d+$/.test(value) && value.length > 6; // Adjust length check based on typical phone numbers

    };

    const checkType = isPhoneNumber(inputValue);
    const handleSendOtp = async (value) => {
        if (inputValue) {
            setLoader(true)
            if (value == "sendOtp") {
                let reqForNum = {
                    phoneNumber: inputValue,
                    countryCode: countryCode,
                    actionType: 1
                }
                let reqForEmail = {
                    email: inputValue,
                    actionType: 1
                }
                try {
                    let res = await forgotpassword(checkType ? reqForNum : reqForEmail)
                    if (res.status === 200) {
                        setLoader(false)
                        toast.success(res?.data?.message)
                        setType(value)
                    } else {
                        setLoader(false)
                        toast.error(res?.response?.data?.message || res?.error || res?.message || "Something went wrong")
                    }
                } catch (error) {
                    setLoader(false)
                    toast.error(error?.response?.data?.message || error?.error || error?.message || "Something went wrong")
                }
            } else if (value == "verifyOtp") {
                let reqForNum = {
                    phoneNumber: inputValue,
                    countryCode: countryCode,
                    otp: 1234,
                    actionType: 1,
                    type: "sms"
                }
                let reqForEmail = {
                    email: inputValue,
                    actionType: 1,
                    otp: 1234,
                    type: "email"
                }
                try {
                    let res = await verifyotp(checkType ? reqForNum : reqForEmail)
                    if (res.status === 200) {
                        setLoader(false)
                        setType(value)
                        setProfileStatus(res?.data?.data?.userDetail);
                        toast.success(res?.data?.message)
                    } else {
                        setLoader(false)
                        toast.error(res?.response?.data?.message || res?.error || res?.message || "Something went wrong")
                    }
                } catch (error) {
                    setLoader(false)
                    toast.error(error?.response?.data?.message || error?.error || error?.message || "Something went wrong")
                }
            } else if (value == "congratulations") {
                let req = {
                    password: password,
                    confirmPassword: confirmPassword,
                    profileStatus: profileStatus?.profileStatus,
                }
                try {
                    let res = await updatepassword(profileStatus?._id, req)
                    if (res.status === 200) {
                        setLoader(false)
                        setType(value)
                        toast.success(res?.data?.message)
                    } else {
                        setLoader(false)
                        toast.error(res?.response?.data?.message || res?.error || res?.message || "Something went wrong")
                    }
                } catch (error) {
                    setLoader(false)
                    toast.error(error?.response?.data?.message || error?.error || error?.message || "Something went wrong")
                }
            }
        } else {
            toast.error("Email or Phone number is required")
        }
    }
    return (
        <Modal centered footer={false} open={openorgotPasModal} onOk={handleCancelForgotPasModal} onCancel={handleCancelForgotPasModal}>
            <ForgotWrapper>
                {
                    type === "sendOtp" ?
                        <div className='verification-div'>
                            <h1 className='main-heading'>Enter Verification Code</h1>
                            <div className='otp-input'>
                                <InputOTP length={4} inputType="numeric" onChange={(value) => console.log('Entered OTP:', value)} />
                            </div>
                            <div className='otp-time'>
                                <p>Didn’t get OTP code? <span>Resend</span></p>
                                <p style={{ color: "#0DA982" }}>01:59</p>
                            </div>
                            <div className='btn-div'>
                                <button onClick={() => handleSendOtp("verifyOtp")}>{loader ? "Loading..." : "VERIFY OTP"}</button>
                            </div>
                        </div> : type === "verifyOtp" ?
                            <div className='verify-otp-div'>
                                <h1 className='main-heading'>Reset Password</h1>
                                <div className='input-div-2'>
                                    <div>
                                        <img src={PasswordIcon} alt="" className='mail-icon' />
                                        <input type='password' name='password' placeholder='Enter Password' onChange={(e) => setPassword(e?.target?.value)} />
                                    </div>
                                    <div>
                                        <img src={PasswordIcon} alt="" className='mail-icon' />
                                        <input type='password' name='confirmPassword' placeholder='Confirm password' onChange={(e) => setConfirmPassword(e?.target?.value)} />
                                        <img src={ShowPassIcon} alt="" className='eye-icon' />
                                    </div>
                                </div>
                                <div className='btn-div'>
                                    <button onClick={() => handleSendOtp("congratulations")}>{loader ? "Loading..." : "Confirm password"}</button>
                                </div>
                            </div>
                            : type === "congratulations" ?
                                <div className='congratulation-div'>
                                    <h1 className='congratts-heading'>Congratulations</h1>
                                    <p className='congratts-para'>Your password has been reset</p>
                                    <div className='congrats-img-div'>
                                        <img src={CongratsIcon} alt="" className='congratts-img' />
                                    </div>
                                    <div className='signin-method'>
                                        <button onClick={() => handleCancelForgotPasModal()}>SIGN IN <img src={AuthArrow} alt="" /></button>
                                    </div>
                                </div>
                                : <div className='email-phone'> <h1 className='main-heading'>Forget Password</h1>
                                    <p className='main-para'>Please enter your email address or mobile number<br />
                                        to reset password</p>
                                    {/* <div className='input-div'>
                                        <img src={LoginMailIcon} alt="" className='mail-icon' />
                                        <input type='text' name='text' placeholder='Email or Phone number' />
                                    </div>*/}
                                    <div className='input-div' style={{ border: "none", padding: "0px" }}>
                                        {isPhoneNumber(inputValue) && (
                                            <select
                                                value={countryCode}
                                                onChange={(e) => setCountryCode(e.target.value)}
                                                style={{ marginRight: "8px" }}
                                                className='country-code'
                                            >
                                                {cousntryCodesArr?.map((val) => {
                                                    return (
                                                        <option value={val?.code}>
                                                            {val?.code} {val?.name}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        )}
                                        <div style={{ display: "flex", alignItems: "center", marginTop: "0px" }}>
                                            <input
                                                type="text"
                                                value={inputValue}
                                                onChange={handleInputCheck}
                                                placeholder="Email or Phone number"
                                            />
                                            <img src={LoginMailIcon} alt="" className='mail-icon' />
                                        </div>
                                    </div>
                                    <div className='btn-div' style={{ border: "none" }}>
                                        <button onClick={() => handleSendOtp("sendOtp")}>{loader ? "Loading..." : "SEND OTP"}</button>
                                    </div></div>
                }

            </ForgotWrapper>
        </Modal>
    )
}

export default ForgotPasswordModal;

const ForgotWrapper = styled.div`
padding-bottom:30px;
.main-heading{
    margin-bottom:33px;
    text-align:center;
    margin-top:40px;
}
    .main-para{
        text-align:center;
        font-size:19px;
    }
    .input-div{
        margin:auto;
        margin-top:35px;
        margin-bottom:35px;
        border:1px solid #E4DFDF;
        border-radius:12px;
        height:70px;
        display:flex;
        align-items:center;
        gap:15px;
        position:relative;
        max-width:383px;
        width:100%;

        .mail-icon{
            width:27px;
            height:27px;
            position:absolute;
            z-index:9;
            left:20px;
        }
        .eye-icon{
            width:29px;
            height:30px;
            position:absolute;
            z-index:9;
            right:20px;
        }
        input{
            font-size:14px;
            font-weight:400;
            border:none;
            height:100%;
            position:relative;
            padding:0px 60px;
            border-radius:12px;
            width:100%;

            &:focus{
                outline:none;
            }
        }
    }
    .btn-div{
        display:flex;
        align-items:center;
        justify-content:center;
        
        button{
            height:48px;
            background:#0DA982;
            color:#fff;
            font-size:16px;
            font-weight:700;
            border:none;
            max-width:225px;
            width:100%;
            border-radius:15px;
            cursor:pointer;
        }
    }

    .verification-div{
        .main-heading{
            font-size:23px;
            font-weight:700;
        }
            .otp-input{
                margin-bottom:52px;
            }
        .otp-time{  
            display:flex;
            align-items:center;
            justify-content:space-between;
            width:78%;
            margin:auto;
            p{ 
                font-size:15px;
                color:#64748B;
                span{
                    font-weight:700;
                    color:#0DA982;
                }
            }
        }
            .btn-div{
        display:flex;
        align-items:center;
        justify-content:center;
        
        button{
            height:48px;
            background:#0DA982;
            color:#fff;
            font-size:16px;
            font-weight:700;
            border:none;
            max-width:225px;
            width:100%;
            border-radius:15px;
            margin-top:46px;
            cursor:pointer;
        }
        }
    }
    .verify-otp-div{
        .main-heading{
            font-size:23px;
            font-weiht:700;
        }
            .input-div-2{
                    div{
                        margin:auto;
                        margin-top:31px;
                        border:1px solid #E4DFDF;
                        border-radius:12px;
                        height:70px;
                        display:flex;
                        align-items:center;
                        gap:15px;
                        position:relative;
                        max-width:383px;
                        width:100%;

                        .mail-icon{
                            width:27px;
                            height:27px;
                            position:absolute;
                            z-index:9;
                            left:20px;
                        }
                        .eye-icon{
                            width:29px;
                            height:30px;
                            position:absolute;
                            z-index:9;
                            right:20px;
                        }
                        input{
                            font-size:14px;
                            font-weight:400;
                            border:none;
                            height:100%;
                            position:relative;
                            padding:0px 60px;
                            border-radius:12px;
                            width:100%;

                            &:focus{
                                outline:none;
                            }
                        }
                    }
                }
                    .btn-div{
        display:flex;
        align-items:center;
        justify-content:center;
        
        button{
            height:48px;
            background:#0DA982;
            color:#fff;
            font-size:16px;
            font-weight:700;
            border:none;
            width:100%;
            border-radius:15px;
            padding:0px 15px;
            margin-top:37px;
            cursor:pointer;
        }
    }
    }
    .congratulation-div{
        .congratts-heading{
            font-size:23px;
            font-weight:700;
            text-align:center;
            margin-top:40px;
        }
        .congratts-para{
            font-size:23px;
            font-weight:400;
            margin-top:26px;
            margin-bottom:56px;
            text-align:center;
        }
        .congrats-img-div{
            display:flex;
            align-items:center;
            justify-content:center;
            margin-bottom:51px;
            .congratts-img{
                width:132px;
                height:132px;
            }
        }
        .signin-method{
            display:flex;
            align-items:center;
            justify-content:center;
            
            button{
                color:#fff;
                font-size:16px;
                font-weight:400;
                background:#0DA982;
                height:48px;
                padding:0px 30px;
                position:relative;
                border:none;
                border-radius:15px;
                display:flex;
                align-items:center;
                max-width:225px;
                width:100%;
                justify-content:center;
                cursor:pointer;

                img{
                    position:absolute;
                    width:24px;
                    height:24px;
                    right:10px;
                }
            }
        }
    }
    .email-phone{
        div{
                        margin:auto;
                        margin-top:31px;
                        border:1px solid #E4DFDF;
                        border-radius:12px;
                        height:70px;
                        display:flex;
                        align-items:center;
                        gap:15px;
                        position:relative;
                        max-width:383px;
                        width:100%;

                        .country-code{
                            height:70px;
                            border-radius:12px;
                            border:1px solid #E4DFDF;
                        }

                        .mail-icon{
                            width:27px;
                            height:27px;
                            position:absolute;
                            z-index:9;
                            left:20px;
                        }
                        .eye-icon{
                            width:29px;
                            height:30px;
                            position:absolute;
                            z-index:9;
                            right:20px;
                        }
                        input{
                            font-size:14px;
                            font-weight:400;
                            border:none;
                            height:100%;
                            position:relative;
                            padding:0px 60px;
                            border-radius:12px;
                            width:100%;

                            &:focus{
                                outline:none;
                            }
                        }
                    }
    }
`;